import React, { useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../_metronic/layout";
import AccountInformation from "./AccountInformation";
import { ProfileOverview } from "./ProfileOverview";
import ChangePassword from "./ChangePassword";
import PersonaInformation from "./PersonaInformation";
import EmailSettings from "./EmailSettings";
import ProfileCard from "./components/ProfileCard";
import UserMobileNavigation from "./components/UserMobileNavigation";
import * as userService from "../../../services/management/userService";
import * as userProfile from "../../../redux/userProfileOverviewRedux";
import UserProfileCredential from "./UserProfileCredential";
import UserProfileRoute from "../CustomRoutes/UserProfileRoute";

const UserProfilePage = (props) => {
  const { location, updateUserProfile, auth } = props
  const viewLogsHandlerRef = useRef(null);
  const suhbeader = useSubheader();
  suhbeader.setTitle("User profile");

  let userId = location.pathname.split('/').pop();
  useEffect(() => {
    userService.getProfileCardInfo(userId).then(res => {
      updateUserProfile(res);
    })
  }, [])

  const registerViewLogsHandler = useCallback((handler) => {
    viewLogsHandlerRef.current = handler;
  }, []);

  const handleViewLogs = useCallback(() => {
    if (viewLogsHandlerRef.current) {
      viewLogsHandlerRef.current();
    }
  }, []);

  return (
    <div className="aes-user-detail-layout d-flex flex-row">
      <ProfileCard userId={userId} onViewLogsReady={registerViewLogsHandler}></ProfileCard>
      <div className="aes-user-detail-content flex-row-fluid ml-lg-8">
        <UserMobileNavigation
          userId={userId}
          userProfile={props.userProfileState}
          auth={auth}
          onViewLogs={handleViewLogs}
        />
        <Switch>
          <Redirect
            from="/management/user-profile/:userId"
            exact={true}
            to="/management/user-profile/personal-information/:userId"
          />
          {/* <Route
            path="/management/user-profile/profile-overview/:id"
            component={ProfileOverview}
          /> */}
          <UserProfileRoute
            path="/management/user-profile/personal-information/:userId"
            component={PersonaInformation}
            userId={userId}
          />
          <UserProfileRoute
            path="/management/user-profile/account-information/:userId"
            component={AccountInformation}
            userId={userId}
          />
          <UserProfileRoute
            path="/management/user-profile/change-password/:userId"
            component={ChangePassword}
            userId={userId}
          />
          <UserProfileRoute
            path="/management/user-profile/credentials/:userId"
            component={UserProfileCredential}
            userId={userId}
          />
        </Switch>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  userProfileState: state.userProfile
})

export default connect(mapStateToProps, userProfile.actions)(UserProfilePage);
